<template>
  <div id="app">
    <TemplateConfig />
    <Spinner />
    <div v-show="enableTemplate">
      <template v-if="$route.name === 'DemoNewDesign'">
        <router-view :secret="secret" style="min-height: 75vh" @changeLinkName="changeLinkName" />
      </template>
      <template v-else-if="$route.name === 'UpdateNewDesign'">
        <router-view :secret="secret" style="min-height: 75vh" @changeLinkName="changeLinkName" />
      </template>
      <template v-else>
        <HeaderAirline v-if="token" :token="token" />
        <Header v-else :secret="secret" :link-name="linkName" />
        <router-view :secret="secret" style="min-height: 75vh" @changeLinkName="changeLinkName" />
        <BoardingPlane :secret="secret" />
        <Footer />
      </template>
    </div>
  </div>
</template>
<script>
import Header from './components/Header/index'
import HeaderAirline from './components/Header/airline'
import Footer from './components/Footer/index'
import Spinner from './components/Spinner/index'
import '@/assets/css/fontawesome/fontawesome.css'
import TemplateConfig from './components/TemplateConfig/index'
import BoardingPlane from './components/BoardingPlane/index'
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps)

export default {
  name: 'App',
  components: {
    BoardingPlane,
    TemplateConfig,
    Header,
    HeaderAirline,
    Footer,
    Spinner
  },
  data() {
    return {
      secret: this.$route.query.secret,
      token: this.$route.query.token,
      linkName: 'Home',
      googleMapsApiLoaded: false
    }
  },
  computed: {
    enableTemplate() {
      return (
        !_.isEmpty(this.airline) ||
        _.includes(['Privacy', 'Disclaimer', 'Impressum', 'VirtualHelpdesk'], this.$route.name) ||
        location.pathname === '/page-error'
      )
    }
  },
  watch: {
    pax: function () {
      // Passenger from Amadeus virtual help desk is only access to confirm Virtual HelpDesk.
      if (this.$route.name !== 'ConfirmVirtualHelpdesk' && this.pax.amadeus_virtual_desk) {
        this.$router.push({ path: '/error' })
      }
      if (this.pax.params && _.isUndefined(this.pax.params.opened)) {
        // Call API update passenger had opened
        this.$store.dispatch('updatePassengerInfo', {
          params: {
            opened: 1 // Flag check passenger had open mobile
          }
        })
      }
    },
    airline: function () {
      this.loadGoogleMapsApi()
    }
  },
  created() {
    if (!this.secret && !_.includes(['Privacy', 'Disclaimer', 'Impressum', 'VirtualHelpdesk'], this.$route.name)) {
      let shortCode = this.$route.path.replace('/', '')
      if (_.size(shortCode) > 9) {
        // Currently generated short code length at least 10 characters
        this.$store.dispatch('getOriginCode', shortCode).then(
          (response) => {
            if (response?.success) {
              window.location.href = response.data.origin_code
            } else {
              this.navigateToPageError()
            }
          },
          (error) => {
            this.navigateToPageError()
          }
        )
      } else {
        this.navigateToPageError()
      }
    }
  },
  methods: {
    loadGoogleMapsApi() {
      if (this.googleMapsApiLoaded || !this.airline || !this.airline.google_map_key) {
        return
      }

      let loadOptions = {
        key: this.airline.google_map_key,
        libraries: 'places',
        async: true
      }

      if (this.airline.feature_flags && this.airline.feature_flags['SFS-6292']) {
        loadOptions.v = 'quarterly'
      }

      try {
        VueGoogleMaps.loadGmapApi(loadOptions)
        this.googleMapsApiLoaded = true
      } catch (error) {
        if (!window.google || !window.google.maps) {
          throw error
        }
        this.googleMapsApiLoaded = true
      }
    },
    changeLinkName: function (newLinkName) {
      this.linkName = newLinkName
    },
    navigateToPageError: function () {
      if (location.pathname !== '/page-error') {
        this.$router.push({ path: '/page-error' })
      }
    }
  }
}
</script>
<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
